import 'styles/PhotoFeed.less'
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import Waypoint from 'react-waypoint'
import classNames from 'classnames/bind'
import Loading from 'components/Utils/Loading'
import * as actions from 'actions'
import photo from '../../../datas/photos/index.json'
import PhotoGridRow from 'components/Gallery/PhotoGridRow'

class Camp2016PhotoFeed extends Component {
  static names = {
    HERO: 'hero',
    THEME: 'theme',
    REGULAR: 'regular',
    initialFeedSize: 12
  }
  constructor(props) {
    super(props)

    this.ALBUMS = {
      'bali': {
        [Camp2016PhotoFeed.names.HERO]: 'camp-2016-bali-hero',
        [Camp2016PhotoFeed.names.THEME]: 'camp-2016-bali-theme',
        [Camp2016PhotoFeed.names.REGULAR]: 'camp-2016-bali'
      },
      'chiba': {
        [Camp2016PhotoFeed.names.HERO]: 'camp-2016-chiba-hero',
        [Camp2016PhotoFeed.names.THEME]: 'camp-2016-chiba-theme',
        [Camp2016PhotoFeed.names.REGULAR]: 'camp-2016-chiba'
      },
      'danube': {
        [Camp2016PhotoFeed.names.HERO]: 'camp-2016-danube-hero',
        [Camp2016PhotoFeed.names.THEME]: 'camp-2016-danube-theme',
        [Camp2016PhotoFeed.names.REGULAR]: 'camp-2016-danube'
      }
    }

    this.initFeed(this.props.campId)
    this.onLoad = this.onLoad.bind(this)
    this._extendList = this._extendList.bind(this)
  }

  initFeed(campId) {
    let heroImages = photo[this.ALBUMS[campId][Camp2016PhotoFeed.names.HERO]].image
    let themeImages = photo[this.ALBUMS[campId][Camp2016PhotoFeed.names.THEME]].image
    let regularImages = photo[this.ALBUMS[campId][Camp2016PhotoFeed.names.REGULAR]].image
    let imageRowsObj = this.getImageOrder(heroImages, regularImages, themeImages)
    let imageRows = imageRowsObj.imageRows
    let rowsOnScreen = Camp2016PhotoFeed.names.initialFeedSize

    if (this.state) {
      this.setState({
        campId: this.props.campId,
        heroImages: photo[this.ALBUMS[campId][Camp2016PhotoFeed.names.HERO]].image,
        themeImages: photo[this.ALBUMS[campId][Camp2016PhotoFeed.names.THEME]].image,
        regularImages: photo[this.ALBUMS[campId][Camp2016PhotoFeed.names.REGULAR]].image,
        imageRows: imageRows,
        rowsOnScreen: rowsOnScreen,
        isLoading: false
      })
    } else {
      this.state = {
        campId: this.props.campId,
        heroImages: photo[this.ALBUMS[campId][Camp2016PhotoFeed.names.HERO]].image,
        themeImages: photo[this.ALBUMS[campId][Camp2016PhotoFeed.names.THEME]].image,
        regularImages: photo[this.ALBUMS[campId][Camp2016PhotoFeed.names.REGULAR]].image,
        imageRows: imageRows,
        rowsOnScreen: rowsOnScreen,
        isLoading: false
      }
    }
  }

  getRandom(x, y) {
    return (Math.round(Math.random() * (y - x)) + x)
  }

  getImageOrder(heroImages, regularImages, themeImages) {
    heroImages.map((image, i) => {
      image.type = Camp2016PhotoFeed.names.HERO
      image.display = true
      image.next = image.prev = null
    })

    regularImages.map((image, i) => {
      image.type = Camp2016PhotoFeed.names.REGULAR
      image.display = true
      image.next = image.prev = null
    })

    themeImages.map((image, i) => {
      image.type = Camp2016PhotoFeed.names.THEME
      image.display = true
      image.next = image.prev = null
    })

    let imageRows = []
    let ratio = Math.floor(regularImages.length / heroImages.length)
    if (ratio < 1)
      ratio = 1

    let heroIndex = 0, regularIndex = 0

    while (heroIndex < heroImages.length || regularIndex < regularImages.length) {
      //console.log(heroIndex + ' ' + regularIndex)
      if (heroIndex < heroImages.length) {
        imageRows.push({
          type: Camp2016PhotoFeed.names.HERO,
          images: [heroImages[heroIndex]]
        })
        heroIndex++
      }

      for (let i = 0; i < ratio; i++) {
        if (regularIndex < regularImages.length) {
          regularImages[regularIndex].position = 'left'
          let currentRowImages = [regularImages[regularIndex]]
          regularIndex++
          if (this.getRandom(0, 9) < 3 && regularIndex < regularImages.length) {
            // Place one on the left, one on the right
            currentRowImages.push(regularImages[regularIndex])
            regularImages[regularIndex].position = 'right'
            regularIndex++
          } else {
            // If we don't have a second image on this row, place the current image at random between left and right.
            currentRowImages[0].position = (this.getRandom(0, 1) == 0) ? 'left' : 'right'
            // Insert the same image in front of the current image
            // TODO (cmocan): This needs to be changed into a more legit way. I'm drunk and need to make it work right now.
            if (currentRowImages[0].position == 'right') {
              let duplicate = Object.assign({}, currentRowImages[0])
              currentRowImages.unshift(duplicate)
              currentRowImages[0].position = classNames('left', 'no-show')
              currentRowImages[0].display = false
            }
          }

          imageRows.push({
            type: Camp2016PhotoFeed.names.REGULAR,
            images: currentRowImages
          })

        } else {
          break
        }
      }
    }

    let themeIndex = 0
    let themeConsecutiveRows = 0
    let position
    while ((position = this.getRandom(0, imageRows.length)) == 0);

    while (themeIndex < themeImages.length) {
      if (this.getRandom(1, Math.pow(2, themeConsecutiveRows + 1)) == 1) {
        // With probability 1 / 2^consecutive_theme_rows, add another row of 3
        position++
      } else {
        while ((position = this.getRandom(0, imageRows.length)) == 0);
        themeConsecutiveRows = 0
      }

      let currentRowImages = []
      themeImages[themeIndex].position = 'left'
      currentRowImages.push(themeImages[themeIndex])
      themeIndex++
      if (themeIndex < themeImages.length) {
        themeImages[themeIndex].position = 'middle'
        currentRowImages.push(themeImages[themeIndex])
        themeIndex++
        if (themeIndex < themeImages.length) {
          themeImages[themeIndex].position = 'right'
          currentRowImages.push(themeImages[themeIndex])
          themeIndex++
        }
      }

      let objToInsert = {
        type: Camp2016PhotoFeed.names.THEME,
        images: currentRowImages
      }

      imageRows.splice(position, 0, objToInsert)
      themeConsecutiveRows++

    }

    let imageOrder = this.getImageOrderForNavigation(imageRows)
    this.setupImageNextPrev(imageOrder)

    return {
      imageRows: imageRows
    }
  }

  setupImageNextPrev(imageOrder) {
    imageOrder.map((image, i) => {
      if (i == 0) {
        image.next = imageOrder[i + 1]
        image.prev = imageOrder[imageOrder.length - 1]
      } else if (i == imageOrder.length - 1) {
        image.next = imageOrder[0]
        image.prev = imageOrder[i - 1]
      } else {
        image.next = imageOrder[i + 1]
        image.prev = imageOrder[i - 1]
      }
    })
  }

  getImageOrderForNavigation(imageRows) {
    let imageOrder = []
    imageRows.map((row, i) => {
      row.images.map((image, i) => {
        if (image.display) {
          imageOrder.push(image)
        }
      })
    })

    return imageOrder
  }

  componentWillReceiveProps(nextProps) {
    //if (nextProps.campId != this.state.campId) {
      this.initFeed(nextProps.campId)
    //}
  }

  onLoad(doc) {
    this.setState({
      docLoaded:true,
      attributes:doc.getAttributes()
    })
  }

  _extendList() {
    let currentRowsOnScreen = this.state.rowsOnScreen
    this.setState({
      rowsOnScreen: Math.min(currentRowsOnScreen + Camp2016PhotoFeed.names.initialFeedSize, this.state.imageRows.length),
      isLoading: false
    })
  }

  infiniteScroll(e) {
    if (!this.refs.photoFeedContainer)
      return
    let currPosition = window.scrollY
    let containerHeight = this.refs.photoFeedContainer.offsetHeight

    //console.log(currPosition + ' ' + containerHeight)
    //console.log(this.state.rowsOnScreen + ' ' + this.state.imageRows.length)

    if (currPosition + (window.innerHeight * 1.3) >= containerHeight && !this.state.isLoading && this.state.rowsOnScreen < this.state.imageRows.length) {
      this.setState({
        isLoading: true
      })
      this._extendList()
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.infiniteScroll.bind(this), false)
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.infiniteScroll, false)
  }

  render() {
    let displayRows = this.state.imageRows.slice(0, this.state.rowsOnScreen)
    let loadingClass = classNames({'no-display': !this.state.isLoading})
    //console.log(displayRows)
  	return (
  		<div className="camp-2016-photo-feed" ref="photoFeedContainer">
        { displayRows.map((row, i) => {
          return (<PhotoGridRow row={row} key={i}/>)
        })}
        <Loading className={loadingClass}/>
  		</div>

  	)
	}
}

Camp2016PhotoFeed.contextTypes = {
}
Camp2016PhotoFeed.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location,
    alertIsClosed: state.token.alertIsClosed,
    footerIsHidden: state.token.footerIsHidden
  }
}

export default connect(mapStateToProps)(Camp2016PhotoFeed)



// WEBPACK FOOTER //
// ./src/components/Gallery/Camp2016PhotoFeed.js